"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _select = _interopRequireDefault(require("../../select"));
var _icon = _interopRequireDefault(require("../../icon"));
var _Searchable = _interopRequireDefault(require("../Searchable"));
var _Function = _interopRequireDefault(require("../Function"));
var _button = require("../../button");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable max-lines-per-function */
var getInteractionData = function getInteractionData(operator, value) {
  switch (operator) {
    case '<':
      return {
        max: value,
        min: null,
        isInclusive: false
      };
    case '>':
      return {
        min: value,
        max: null,
        isInclusive: false
      };
    case '<=':
      return {
        max: value,
        min: null,
        isInclusive: true
      };
    case '>=':
      return {
        min: value,
        max: null,
        isInclusive: true
      };
    default:
      return {};
  }
};
var thresholdOperators = [{
  value: '<',
  label: '<'
}, {
  value: '>',
  label: '>'
}, {
  value: '<=',
  label: '<='
}, {
  value: '>=',
  label: '>='
}];
var BlockWrapper = function BlockWrapper(_ref) {
  var data = _ref.data,
    blockData = _ref.blockData,
    blockType = _ref.blockType,
    interactionType = _ref.interactionType,
    actions = _ref.actions,
    labels = _ref.labels,
    thresholdIndex = _ref.thresholdIndex,
    errors = _ref.errors,
    disabled = _ref.disabled,
    ruleIndex = _ref.ruleIndex,
    isFocused = _ref.isFocused,
    thresholds = _ref.thresholds,
    thresholdRowIndex = _ref.thresholdRowIndex,
    andData = _ref.andData,
    clearFocus = _ref.clearFocus;
  var bockSeparator = function bockSeparator() {
    /*#__PURE__*/_react["default"].createElement("span", null, "and");
  };
  if (!interactionType) return '';
  if (interactionType === 'between') {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, isFocused && /*#__PURE__*/_react["default"].createElement(_button.Button, {
      disabled: disabled,
      className: "formula-button delete-member",
      onMouseDown: function onMouseDown(ev) {
        var morphedData = R.clone(thresholds);
        ev.stopPropagation();
        morphedData.thresholdRows[thresholdRowIndex] = _objectSpread(_objectSpread({}, morphedData.thresholdRows[thresholdRowIndex]), {}, {
          max: null,
          min: null,
          isBetween: false,
          isInclusive: false
        });
        actions.thresholdChange('update', {
          thresholdIndex: thresholdIndex,
          thresholdData: morphedData
        });
        clearFocus();
      },
      type: "naked"
    }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      icon: "ion-android-delete",
      size: 16
    })), /*#__PURE__*/_react["default"].createElement(_Function["default"], {
      disabled: disabled,
      keysPath: [],
      className: "threshold-element",
      value: labels.FORMULA_BETWEEN_FUNCTION_HEADER_LABEL,
      ruleIndex: 0,
      args: [[blockData.min], [blockData.max]],
      labels: {},
      renderMember: function renderMember(_ref2) {
        var keysPath = _ref2.keysPath,
          member = _ref2.member;
        return /*#__PURE__*/_react["default"].createElement(_Searchable["default"], {
          isFocused: isFocused,
          disabled: disabled,
          key: keysPath.join('-'),
          id: "".concat(ruleIndex, "-threshold-between-function-").concat(thresholdRowIndex, "-").concat(thresholdIndex, "-").concat(keysPath.join('-')),
          keysPath: [],
          description: R.prop('description', member),
          error: R.path(['thresholdRows', thresholdRowIndex, keysPath[1] === 0 ? 'min' : 'max'], errors),
          labels: labels,
          formulaChange: function formulaChange(update) {
            var ruleThresholds = R.clone(data);
            ruleThresholds.thresholdRows[thresholdRowIndex][keysPath[1] === 0 ? 'min' : 'max'] = update;
            actions.thresholdChange('update', {
              thresholdIndex: thresholdIndex,
              thresholdData: ruleThresholds
            });
          },
          displayName: R.prop('displayName', member),
          value: R.prop('value', member),
          searchableAction: actions.getFormulaOperandValues,
          isFullWidth: false
        });
      },
      index: 0,
      formulaChange: function formulaChange() {},
      separator: function separator() {
        return bockSeparator();
      }
    }), isFocused && blockType !== 'and' && !andData && /*#__PURE__*/_react["default"].createElement(_button.Button, {
      disabled: disabled,
      className: "formula-button add-member",
      onMouseDown: function onMouseDown(ev) {
        var morphedData = R.clone(thresholds);
        ev.stopPropagation();
        morphedData.thresholdRows.push({
          field: 'age',
          min: null,
          max: null,
          date: null
        });
        actions.thresholdChange('update', {
          thresholdIndex: thresholdIndex,
          thresholdData: morphedData
        });
        clearFocus();
      },
      type: "naked"
    }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      icon: "ion-plus",
      size: 16
    })));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "threshold-element"
  }, /*#__PURE__*/_react["default"].createElement(_select["default"], {
    disabled: disabled,
    id: "".concat(ruleIndex, "-threshold-select-").concat(blockType, "-").concat(thresholdIndex),
    placeholder: "",
    className: "formula-operator",
    onChange: function onChange(update) {
      var ruleThresholds = R.clone(data);
      ruleThresholds.thresholdRows[thresholdRowIndex].operator = update.value;
      if (ruleThresholds.thresholdRows[thresholdRowIndex].member && ruleThresholds.thresholdRows[thresholdRowIndex].operator) {
        ruleThresholds.thresholdRows[thresholdRowIndex] = _objectSpread(_objectSpread({}, ruleThresholds.thresholdRows[thresholdRowIndex]), getInteractionData(ruleThresholds.thresholdRows[thresholdRowIndex].operator, ruleThresholds.thresholdRows[thresholdRowIndex].member));
      }
      actions.thresholdChange('update', {
        thresholdIndex: thresholdIndex,
        thresholdData: ruleThresholds
      });
    },
    errors: R.path(['thresholdRows', thresholdRowIndex, 'operator'], errors),
    options: thresholdOperators,
    value: blockData.operator,
    searchable: false
  })), /*#__PURE__*/_react["default"].createElement(_Searchable["default"], {
    isFocused: isFocused,
    disabled: disabled,
    id: "".concat(ruleIndex, "-threshold-searchable-").concat(blockType, "-").concat(thresholdIndex),
    type: "variable",
    keysPath: [],
    description: R.path(['member', 'description'], blockData),
    labels: labels,
    formulaChange: function formulaChange(update) {
      var ruleThresholds = R.clone(data);
      ruleThresholds.thresholdRows[thresholdRowIndex].member = update;
      if (ruleThresholds.thresholdRows[thresholdRowIndex].member && ruleThresholds.thresholdRows[thresholdRowIndex].operator) {
        ruleThresholds.thresholdRows[thresholdRowIndex] = _objectSpread(_objectSpread({}, ruleThresholds.thresholdRows[thresholdRowIndex]), getInteractionData(ruleThresholds.thresholdRows[thresholdRowIndex].operator, ruleThresholds.thresholdRows[thresholdRowIndex].member));
      }
      actions.thresholdChange('update', {
        thresholdIndex: thresholdIndex,
        thresholdData: ruleThresholds
      });
    },
    displayName: R.path(['member', 'displayName'], blockData),
    error: R.path(['thresholdRows', thresholdRowIndex, 'member'], errors),
    value: R.path(['member', 'value'], blockData),
    searchableAction: actions.getFormulaOperandValues,
    isFullWidth: false
  }));
};
BlockWrapper.defaultProps = {
  errors: {},
  disabled: false,
  blockType: '',
  interactionType: '',
  isFocused: false,
  andData: undefined
};
BlockWrapper.propTypes = {
  disabled: _propTypes["default"].bool,
  /* The threshold index */
  thresholdIndex: _propTypes["default"].number.isRequired,
  /* The rule index */
  ruleIndex: _propTypes["default"].number.isRequired,
  /* The thresholdRowIndex index */
  thresholdRowIndex: _propTypes["default"].number.isRequired,
  /* The rewards labels */
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  /* The store function update */
  clearFocus: _propTypes["default"].func.isRequired,
  /* The root data for each threshold */
  data: _propTypes["default"].shape({}).isRequired,
  /* The block data for each threshold (if - and) */
  blockData: _propTypes["default"].shape({
    min: _propTypes["default"].number,
    max: _propTypes["default"].number,
    operator: _propTypes["default"].string
  }).isRequired,
  /* The block data for each threshold (if - and) */
  andData: _propTypes["default"].shape({}),
  /* The errros object */
  errors: _propTypes["default"].shape({}),
  actions: _propTypes["default"].objectOf(_propTypes["default"].func).isRequired,
  /* The root thresholds for each threshold */
  thresholds: _propTypes["default"].shape({}).isRequired,
  blockType: _propTypes["default"].string,
  interactionType: _propTypes["default"].string,
  isFocused: _propTypes["default"].bool
};
var _default = exports["default"] = BlockWrapper;